import { apiRequest as request } from '../req'

/**
 * 组局列表
 * @params {Object}
 */
export function gatherList(params) {
  return request({
    url: '/gather/list',
    method: 'get',
    params
  })
}
/**
 * 生成登录二维码
 * @params {Object}
 */
export function createScanCode(params) {
  return request({
    url: '/venue/createCode',
    method: 'get',
    params
  })
}
/**
 * 生成登录二维码
 * @params {Object}
 */
export function scanCodeInfo(params) {
  return request({
    url: '/scan_code/info',
    method: 'get',
    params
  })
}

// 场地详情
export function getVenueInfo(params) {
  return request({
    url: '/venue/info',
    method: 'get',
    params
  })
}

// 收礼和送礼榜单
export function giftRank(params) {
  return request({
    url: '/log_send_gift/rank',
    method: 'GET',
    params
  })
}

// 大屏：本场求组信号看板（公开，无需登录）
export function boardSignals(params) {
  return request({
    url: '/match/boardSignals',
    method: 'GET',
    params
  })
}

// 本场入场码信息（公开；有小程序码则返回 image_url）
export function entranceCodeInfo(params) {
  return request({
    url: '/venue/entranceCodeInfo',
    method: 'GET',
    params
  })
}

/** 大屏公开：分类积分榜（week|month|quarter） */
export function boardPlayScoreRanks(params) {
  return request({
    url: '/match/boardPlayScoreRanks',
    method: 'GET',
    params
  })
}

/** 大屏公开：在场活跃榜 */
export function presentActiveRank(params) {
  return request({
    url: '/match/presentActiveRank',
    method: 'GET',
    params
  })
}
